import React, { useCallback, useEffect, useRef, useState } from 'react'
import FilterPopup from '../components/Table/FilterPopup';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
export const DataTableContext = React.createContext({

})
export const DataTableProvider = ({ 
    children, 
    autoReload, 
    searchPlaceholder,
    customFilters = [], 
    defaultColumns, 
    fetcher, 
    defaultPageSize = 10, 
    defaultSortKey = "id", 
    defaultSortAlign = "desc", 
    actions, 
    defaultFilterConfig = {} 
}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {uid} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [submitting, setSubmitting] = useState(null);
    const [columns, setColumns] = useState([...defaultColumns, ...customFilters]);
    const [sortConfig, setSortConfig] = useState({
        align: defaultSortAlign,
        key: defaultSortKey
    });
    const [fieldOpenFilterModal, setFieldOpenFilterModal] = useState(null);
    const [filterConfig, setFilterConfig] = useState(defaultFilterConfig)
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(defaultPageSize);
    const [totalPage, setTotalPage] = useState(0);
    const [totalRow, setTotalRow] = useState(0);
    const [from, setFrom] = useState(0);
    const [to, setTo] = useState(0);
    const reloadTimeoutRef = useRef(null);
    const stateRef = useRef(null);
    useEffect(() => {
        if(uid){
            setColumns(prevData => 
                prevData.map(col => {
                    if (col.key === "uid") return { ...col, forceFilter: true };
                    return col;
                }
            ));
            appendFilter('uid', uid)
        }
    }, [uid])
    const fetchData = useCallback(async (params) => {
        if(fetcher){
            setIsLoading(true);
            const dataFetched = await fetcher(params);
            setData(dataFetched.data)
            setTotalPage(dataFetched.last_page)
            setFrom(dataFetched.from);
            setTo(dataFetched.to);
            setTotalRow(dataFetched.total)
            setIsLoading(false);
        }
        
    }, [fetcher]);
    useEffect(() => {
        if(autoReload && reloadTimeoutRef.current === null){
            reloadTimeoutRef.current = setInterval(() => {
                console.log("reload data")
                reloadData();
            }, 10000)
        }
        return () => {
            if(reloadTimeoutRef.current) clearInterval(reloadTimeoutRef.current)
        }
    }, [autoReload])
    const reloadData = () => {
        const { currentPage, pageSize, sortConfig, filterConfig } = stateRef.current;
        fetchData({
            page: currentPage,
            limit: pageSize,
            sort: sortConfig.key,
            align: sortConfig.align,
            ...(Object.keys(filterConfig).length > 0 && {
                search: JSON.stringify(filterConfig)
            })
        }); 
    }
    useEffect(() => {
        stateRef.current = {
          currentPage,
          pageSize,
          sortConfig,
          filterConfig
        };
        reloadData();
    }, [currentPage, pageSize, sortConfig, filterConfig]);
    

    
    const changePage = (pageNumber) => {
        setCurrentPage(pageNumber)
        
    }
    const updateRowDataTable = (row) => {
        setData(prevData =>
            prevData.map(item =>
                item.id === row.id ? row : item
            )
        );
    }
    const sort = (key, align) => {
        setSortConfig({
            key,
            align
        })
    }
    const findColumnByKey = (key) => {
        const filtered = columns.filter((field) => field.key === key);
        if(filtered.length > 0) return filtered[0];
        if(key === "keyword") {
            return {
                key: "keyword",
                label: t("Keyword")
            }
        }
        return null;
    }
    const appendFilter = (key, value) => {
        setFilterConfig(prevData => ({
            ...prevData,
            [key]: value
        }));
    }
    const clearFilter = (key) => {
        const column = findColumnByKey(key);
        if(column?.forceFilter) return;
        setFilterConfig(prevData => {
            const newData = { ...prevData };
            delete newData[key];
            return newData;
        });
    };
    const clearAllFilters = () => {
        Object.keys(filterConfig).map((key) => clearFilter(key))
    };
    const openFilterPopup = (col) => {
        setFieldOpenFilterModal(col);
    }
    const closeFilterPopup = () => {
        setFieldOpenFilterModal(null);
    }
    return (
      <DataTableContext.Provider value={{
            columns,
            actions,
            searchPlaceholder,
            isLoading,
            setIsLoading,
            sortConfig,
            totalPage,
            totalRow,
            from,
            to,
            pageSize,
            currentPage,
            changePage,
            data,
            updateRowDataTable,
            submitting,
            setSubmitting,
            sort,
            filterConfig,
            appendFilter,
            clearFilter,
            clearAllFilters,
            openFilterPopup,
            closeFilterPopup,
            fieldOpenFilterModal,
            findColumnByKey,
            customFilters,
            reloadData
        }}>
            {children}
            {fieldOpenFilterModal && (
                <FilterPopup />
            )}
      </DataTableContext.Provider>
    );
  };